import { Link } from 'react-router-dom';
import type { NewsArticle } from '@/mocks/news';

interface NewsCardProps {
  article: NewsArticle;
}

export default function NewsCard({ article }: NewsCardProps) {
  return (
    <Link
      to={`/news/detail/${article.id}`}
      className="group grid grid-cols-1 gap-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:border-primary-300 hover:bg-background-100 sm:grid-cols-[220px_1fr]"
    >
      <div className="h-44 w-full overflow-hidden rounded-md sm:h-32">
        <img
          src={article.cover}
          alt={article.title}
          title={`${article.title} - 蜜桃网影视资讯`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-col">
        <span className="w-fit rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
          {article.category}
        </span>
        <h3 className="mt-2 line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{article.excerpt}</p>
        <span className="mt-auto pt-3 text-xs text-foreground-400">
          {article.author} · {article.date}
        </span>
      </div>
    </Link>
  );
}